export interface CheckboxChangeEventDetail {
    checked: boolean;
}

export type CheckboxLabelAlignment = 'top' | 'center' | 'bottom';
